import ReactLoading from "react-loading";

const Loading = () => (
  <div className="overlay">
    <ReactLoading type={'spin'} color={"#ff7bac"} height={50} width={50}/>
  </div>
);

export default Loading;
